import { IconicLaptopError } from '@insify/design-system/iconic-icons';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import styles from './styles.module.css';

const ErrorBoundaryFallback = () => {
  const error = useRouteError() as Error;
  const componentStack = error.stack?.split('\n').slice(1).join('\n');
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <IconicLaptopError className={styles.errorIcon} />
          <h1 className={styles.errorTitle}>ERROR</h1>
        </div>
        <pre className={styles.errorMessage}>{(error as Error).message}</pre>
        <div className={styles.callStackContainer}>
          <pre className={styles.callStack}>{componentStack}</pre>
        </div>
      </div>
    </div>
  );
};

const RootErrorBoundary: Sentry.FallbackRender = ({ error, componentStack }) => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <IconicLaptopError className={styles.errorIcon} />
          <h1 className={styles.errorTitle}>ERROR</h1>
        </div>
        <pre className={styles.errorMessage}>{(error as Error).message}</pre>
        <div className={styles.callStackContainer}>
          <pre className={styles.callStack}>{componentStack}</pre>
        </div>
      </div>
    </div>
  );
};

export { ErrorBoundaryFallback, RootErrorBoundary };
